module.exports = __webpack_public_path__ + "static/media/plugin-function.a701f2ea.svg";